export default __webpack_public_path__ + "static/media/logo.573902ae.png";